/**
 * @param  {*} x value
 * @return {boolean} isObjLoose
 *
 * @since 3.0.0
 * @memberOf is
 * @func isObjLoose
 * @see is/obj
 * @see is/objWithKeys
 * @see is/objStrict
 * @see is/null
 *
 * @example
 *
 *  isObjLoose(new Object())
 *  //=> true
 *  isObjLoose({})
 *  //=> true
 *  isObjLoose(Object.create(null))
 *  //=> true
 *  isObjLoose(null)
 *  //=> true
 *
 *  isObjLoose(new Set())
 *  //=> false
 *  isObjLoose(function() {})
 *  //=> false
 *  isObjLoose('')
 *  //=> false
 *  isObjLoose(1)
 *  //=> false
 *
 */
module.exports = function (x) { return typeof x === 'object'; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JqTG9vc2UuanMiLCJzb3VyY2VzIjpbIm9iakxvb3NlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQHBhcmFtICB7Kn0geCB2YWx1ZVxuICogQHJldHVybiB7Ym9vbGVhbn0gaXNPYmpMb29zZVxuICpcbiAqIEBzaW5jZSAzLjAuMFxuICogQG1lbWJlck9mIGlzXG4gKiBAZnVuYyBpc09iakxvb3NlXG4gKiBAc2VlIGlzL29ialxuICogQHNlZSBpcy9vYmpXaXRoS2V5c1xuICogQHNlZSBpcy9vYmpTdHJpY3RcbiAqIEBzZWUgaXMvbnVsbFxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogIGlzT2JqTG9vc2UobmV3IE9iamVjdCgpKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzT2JqTG9vc2Uoe30pXG4gKiAgLy89PiB0cnVlXG4gKiAgaXNPYmpMb29zZShPYmplY3QuY3JlYXRlKG51bGwpKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzT2JqTG9vc2UobnVsbClcbiAqICAvLz0+IHRydWVcbiAqXG4gKiAgaXNPYmpMb29zZShuZXcgU2V0KCkpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzT2JqTG9vc2UoZnVuY3Rpb24oKSB7fSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNPYmpMb29zZSgnJylcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNPYmpMb29zZSgxKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiB0eXBlb2YgeCA9PT0gJ29iamVjdCdcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBaUNBLE1BQU0sQ0FBQyxPQUFPLEdBQUcsVUFBQSxDQUFDLENBQUEsQ0FBQyxBQUFHLFNBQUEsT0FBTyxDQUFDLEtBQUssUUFBUSxHQUFBOyJ9